"use client";

// Profile section listing the signed-in player's saved charts: link to the
// share page, Pacific created date, public toggle, delete.
import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
import { useT } from "@/lib/i18n";
import { Link } from "@/i18n/navigation";
import { useToast } from "@/app/components/Toast";
import { fmtDatePacific } from "@/lib/pacific";
import { useGameLocale } from "@/lib/i18n";
import { hreflangOf } from "@/lib/locale";
import type { SavedChartDoc } from "@/lib/saved-chart-spec";
const API = process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8000";
const SOURCE_KEYS: Record<string, string> = {
  cards: "Cards",
  relics: "Relics",
  potions: "Potions",
  shops: "Shops",
  events: "Events",
  campfires: "Campfires"
};
export default function MyChartsSection() {
  const $ = _c(47);
  const t = useT();
  const locale = useGameLocale();
  const {
    toast
  } = useToast();
  const [charts, setCharts] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const token = localStorage.getItem("spire_token");
      if (!token) {
        setCharts([]);
        return;
      }
      fetch(`${API}/api/charts/mine`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(_temp).then(d => setCharts(d)).catch(() => setCharts([]));
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const load = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [load];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useEffect(load, t1);
  let t2;
  if ($[2] !== t || $[3] !== toast) {
    t2 = async (chart, isPublic) => {
      const token_0 = localStorage.getItem("spire_token");
      const res = await fetch(`${API}/api/charts/${chart.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...(token_0 ? {
            Authorization: `Bearer ${token_0}`
          } : {})
        },
        body: JSON.stringify({
          public: isPublic
        })
      });
      if (res.ok) {
        setCharts(cs => cs?.map(c => c.id === chart.id ? {
          ...c,
          public: isPublic
        } : c) ?? null);
      } else {
        toast(t("Save failed. Try again."), "error");
      }
    };
    $[2] = t;
    $[3] = toast;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const setPublic = t2;
  let t3;
  if ($[5] !== t || $[6] !== toast) {
    t3 = async chart_0 => {
      const token_1 = localStorage.getItem("spire_token");
      const res_0 = await fetch(`${API}/api/charts/${chart_0.id}`, {
        method: "DELETE",
        headers: token_1 ? {
          Authorization: `Bearer ${token_1}`
        } : {}
      });
      if (res_0.ok) {
        setCharts(cs_0 => cs_0?.filter(c_0 => c_0.id !== chart_0.id) ?? null);
      } else {
        toast(t("Save failed. Try again."), "error");
      }
    };
    $[5] = t;
    $[6] = toast;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const remove = t3;
  if (charts === null) {
    return null;
  }
  if (charts.length === 0) {
    let t4;
    if ($[8] !== t) {
      t4 = t("My charts");
      $[8] = t;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== t4) {
      t5 = <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-3">{t4}</h2>;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== t) {
      t6 = t("Build a chart in the");
      $[12] = t;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== t) {
      t7 = t("Chart Builder");
      $[14] = t;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== t7) {
      t8 = <Link href="/stats/chart-builder" className="text-[var(--accent-gold)] hover:underline">{t7}</Link>;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== t) {
      t9 = t("and save it here to share it.");
      $[18] = t;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== t6 || $[21] !== t8 || $[22] !== t9) {
      t10 = <p className="text-sm text-[var(--text-muted)]">{t6}{" "}{t8}{" "}{t9}</p>;
      $[20] = t6;
      $[21] = t8;
      $[22] = t9;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    let t11;
    if ($[24] !== t10 || $[25] !== t5) {
      t11 = <section>{t5}{t10}</section>;
      $[24] = t10;
      $[25] = t5;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    return t11;
  }
  let t4;
  if ($[27] !== t) {
    t4 = t("My charts");
    $[27] = t;
    $[28] = t4;
  } else {
    t4 = $[28];
  }
  let t5;
  if ($[29] !== t4) {
    t5 = <h2 className="text-lg font-semibold text-[var(--text-primary)] mb-3">{t4}</h2>;
    $[29] = t4;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  let t6;
  if ($[31] !== charts || $[32] !== locale || $[33] !== remove || $[34] !== setPublic || $[35] !== t) {
    let t7;
    if ($[37] !== locale || $[38] !== remove || $[39] !== setPublic || $[40] !== t) {
      t7 = c_1 => <li key={c_1.id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-card)] px-3 py-2"><div className="min-w-0"><Link href={`/charts/${c_1.id}`} className="text-sm font-medium text-[var(--accent-gold)] hover:underline">{c_1.title}</Link><span className="ml-2 text-xs text-[var(--text-muted)]">{t(SOURCE_KEYS[c_1.spec?.source] ?? c_1.spec?.source ?? "")} ·{" "}{c_1.created_at ? fmtDatePacific(c_1.created_at, {
              year: "numeric",
              month: "short",
              day: "numeric"
            }, hreflangOf(locale)) : ""}</span></div><div className="flex items-center gap-2 text-xs"><button className={`rounded-full border px-3 py-1 ${c_1.public ? "border-[var(--accent-gold)] bg-[var(--accent-gold)]/15 text-[var(--accent-gold)]" : "border-[var(--border-subtle)] text-[var(--text-secondary)]"}`} onClick={() => setPublic(c_1, !c_1.public)}>{c_1.public ? t("Public") : t("Private")}</button><button className="rounded border border-[var(--border-subtle)] px-3 py-1 text-[var(--text-secondary)] hover:border-[var(--danger)] hover:text-[var(--danger)]" onClick={() => remove(c_1)}>{t("Delete")}</button></div></li>;
      $[37] = locale;
      $[38] = remove;
      $[39] = setPublic;
      $[40] = t;
      $[41] = t7;
    } else {
      t7 = $[41];
    }
    t6 = charts.map(t7);
    $[31] = charts;
    $[32] = locale;
    $[33] = remove;
    $[34] = setPublic;
    $[35] = t;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  let t7;
  if ($[42] !== t6) {
    t7 = <ul className="space-y-2">{t6}</ul>;
    $[42] = t6;
    $[43] = t7;
  } else {
    t7 = $[43];
  }
  let t8;
  if ($[44] !== t5 || $[45] !== t7) {
    t8 = <section>{t5}{t7}</section>;
    $[44] = t5;
    $[45] = t7;
    $[46] = t8;
  } else {
    t8 = $[46];
  }
  return t8;
}
function _temp(r) {
  return r.ok ? r.json() as Promise<SavedChartDoc[]> : [];
}